/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */
import { AppIdentifier, DesktopAgent } from "@finos/fdc3";
import { AgentFactory } from "fusion-interop-common/src/types";
import { InteropService } from "fusion-interop-common/src/messaging";
import { AppRefManager } from "fusion-interop-common/src/lifecycle";
import { AppDefinition } from "fusion-interop-common/src/types/app-directory";
import { Pfdc3Agent } from "./Pfdc3Agent";

// prettier-ignore
export const pfdc3AgentFactory: AgentFactory = (browserGlobalScope: Window & typeof globalThis,
                                                appIdentifier: AppIdentifier,
                                                interopService: InteropService,
                                                appRefManager: AppRefManager,
                                                appDef: AppDefinition): DesktopAgent => {
  return new Pfdc3Agent(browserGlobalScope, appIdentifier, interopService, appRefManager, appDef);
};
